/** 鉴别子单列表状态（与小程序 order/index 对齐） */
export const VERIFICATION_ORDER_STATUS = {
  "-1": { title: "未支付", color: "#999" },
  0: { title: "待发货", color: "#e29428" },
  6: { title: "待取件", color: "#e29428" },
  1: { title: "已寄出", color: "#e29428" },
  2: { title: "平台鉴别", color: "#e29428" },
  3: { title: "出具报告", color: "#e29428" },
  4: { title: "寄回", color: "#67c23a" },
  5: { title: "已退款", color: "red" },
  10: { title: "已取消", color: "#909399" },
};

/** 寄售子单列表状态（与 ConsignmentOrderTab.resolveStatusLabel 对齐） */
export const CONSIGNMENT_ORDER_STATUS = {
  "-1": { title: "未支付", color: "#999" },
  0: { title: "待发货", color: "#e29428" },
  6: { title: "待取件", color: "#e29428" },
  1: { title: "已寄出", color: "#e29428" },
  2: { title: "平台鉴别", color: "#e29428" },
  3: { title: "出具报告", color: "#e29428" },
  9: { title: "待确认上架", color: "#409eff" },
  7: { title: "出售中", color: "#67c23a" },
  8: { title: "已售出", color: "#909399" },
  4: { title: "关闭/退回", color: "#f56c6c" },
  5: { title: "已退款", color: "red" },
  10: { title: "已取消", color: "#909399" },
};

export const VERIFICATION_STATUS_FILTERS = [
  { name: "全部状态", status: -2 },
  { name: "待发货", status: 0 },
  { name: "待取件", status: 6 },
  { name: "已寄出", status: 1 },
  { name: "平台鉴别", status: 2 },
  { name: "出具报告", status: 3 },
  { name: "寄回", status: 4 },
  { name: "已退款", status: 5 },
  { name: "已取消", status: 10 },
];

export const CONSIGNMENT_STATUS_FILTERS = [
  { name: "全部状态", status: -2 },
  { name: "待发货", status: 0 },
  { name: "待取件", status: 6 },
  { name: "已寄出", status: 1 },
  { name: "平台鉴别", status: 2 },
  { name: "出具报告", status: 3 },
  { name: "待确认上架", status: 9 },
  { name: "出售中", status: 7 },
  { name: "已售出", status: 8 },
  { name: "关闭/退回", status: 4 },
  { name: "已退款", status: 5 },
  { name: "已取消", status: 10 },
];

export function resolveStatusConfig(status, statusMap) {
  const fallback = { title: "--", color: "#999" };
  if (!statusMap) return fallback;
  const key = status === 0 ? "0" : String(status != null ? status : "");
  return Object.prototype.hasOwnProperty.call(statusMap, key)
    ? statusMap[key]
    : fallback;
}

/** 列表行状态展示：优先 statusLabel，兼容退款中等扩展文案 */
export function resolveRowDisplayStatus(row, statusMap) {
  const fallback = { title: "--", color: "#999" };
  if (!row) return fallback;
  try {
    if (row.statusLabel) {
      const label = String(row.statusLabel);
      if (label.indexOf("退款中") !== -1) {
        return { title: label, color: "#e6a23c" };
      }
      const base = resolveStatusConfig(row.status, statusMap);
      return { title: label, color: base.color };
    }
    return resolveStatusConfig(row.status, statusMap);
  } catch (e) {
    return fallback;
  }
}



// WEBPACK FOOTER //
// ./src/util/xwOrderStatus.js